/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Select_Guide_PlaceholderInputs */

const en_knp_lookup_select_guide_placeholder = /** @type {(inputs: Knp_Lookup_Select_Guide_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Select a guide --`)
};

const fr_knp_lookup_select_guide_placeholder = /** @type {(inputs: Knp_Lookup_Select_Guide_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Selectionner un guide --`)
};

const de_knp_lookup_select_guide_placeholder = /** @type {(inputs: Knp_Lookup_Select_Guide_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Wählen Sie einen Leitfaden --`)
};

const it_knp_lookup_select_guide_placeholder = /** @type {(inputs: Knp_Lookup_Select_Guide_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Seleziona una guida --`)
};

const ru_knp_lookup_select_guide_placeholder = /** @type {(inputs: Knp_Lookup_Select_Guide_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Выберите руководство --`)
};

const es_knp_lookup_select_guide_placeholder = /** @type {(inputs: Knp_Lookup_Select_Guide_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Seleccione una guía --`)
};

const zh_cn2_knp_lookup_select_guide_placeholder = /** @type {(inputs: Knp_Lookup_Select_Guide_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- 选择一位导游 --`)
};

const ja_knp_lookup_select_guide_placeholder = /** @type {(inputs: Knp_Lookup_Select_Guide_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- ガイドを選択 --`)
};

const hi_knp_lookup_select_guide_placeholder = /** @type {(inputs: Knp_Lookup_Select_Guide_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- एक गाइड चुनें --`)
};

const pt_pt2_knp_lookup_select_guide_placeholder = /** @type {(inputs: Knp_Lookup_Select_Guide_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Selecione um guia --`)
};

/**
* | output |
* | --- |
* | "-- Select a guide --" |
*
* @param {Knp_Lookup_Select_Guide_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_select_guide_placeholder = /** @type {((inputs?: Knp_Lookup_Select_Guide_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Select_Guide_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_select_guide_placeholder(inputs)
	if (locale === "de") return de_knp_lookup_select_guide_placeholder(inputs)
	if (locale === "it") return it_knp_lookup_select_guide_placeholder(inputs)
	if (locale === "ru") return ru_knp_lookup_select_guide_placeholder(inputs)
	if (locale === "es") return es_knp_lookup_select_guide_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_select_guide_placeholder(inputs)
	if (locale === "ja") return ja_knp_lookup_select_guide_placeholder(inputs)
	if (locale === "hi") return hi_knp_lookup_select_guide_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_select_guide_placeholder(inputs)
	return en_knp_lookup_select_guide_placeholder(inputs)
});